// @core/api/endpoints/notifications/update_channel.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateChannelRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Update notification channel
 * Updates an existing notification channel's settings. Changes may affect pending notifications in the delivery queue.
 */
export async function UpdateChannel(
  channel_id: string,
  data: UpdateChannelRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/channels/:channel_id`;
  requestPath = requestPath.replace(':channel_id', encodeURIComponent(channel_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
